import { Component, OnInit } from '@angular/core';
import { StringLengthLimiter } from 'src/app/common/helpers/string-length-limiter';
import { Subscription } from 'rxjs';
import { NotifierEvents } from 'src/app/common/enums/enums';
import { ComponentBase } from '../../base/component-base';
import { HistoryService } from 'src/app/services/history.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-breadcrumb-trail',
    templateUrl: './breadcrumb-trail.component.html',
    styleUrls: ['./breadcrumb-trail.component.scss'],
    standalone: false
})

export class BreadcrumbTrailComponent extends ComponentBase implements OnInit {
  breadCrumbList: any[] = [];
  limitLength: number = 30;
  subscriptionRootMember = new Subscription();
  expectedUpdates = [NotifierEvents.RootMemberChanged, NotifierEvents.RootMemberUpdated];

  constructor(
    public stringLimit: StringLengthLimiter,
    private historyService: HistoryService
  ) {
    super();
  }

  ngOnInit(): void {
    this.breadCrumbList = this.historyService.getIndividualList(environment.BREADCRUMB_SIZE + 1);
  }

  notify() {
    this.breadCrumbList = this.historyService.getIndividualList(environment.BREADCRUMB_SIZE + 1);
  }


  breakText = function (text: String, line: number) {
    return this.stringLimit.breakText(text, line, this.limitLength);
  }

  changeRootPerson(item) {
    this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, item);
  }

  ngOnDestroy(): void {
    this.subscriptionRootMember.unsubscribe();
    super.ngOnDestroy();
  }
}
